var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-card"},[_c('span',{staticClass:"terms-card__name"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"terms-card__description"},[_vm._v(" "+_vm._s(_vm.description || "-")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }